/**
 * "Every Tuesday and Thursday at 17:00, for six weeks" → explicit instants.
 *
 * The tutor picks a local wall-clock time and expects every occurrence to
 * be at that wall-clock time. So the walk has to happen in local terms:
 * `setDate(base.getDate() + n)` lets Date re-resolve the UTC offset for the
 * new calendar day, which keeps 17:00 at 17:00 across a daylight-saving
 * boundary. Adding `n * 7 * 86_400_000` milliseconds instead would silently
 * shift every lesson after the clocks change by an hour.
 *
 * `now` is a parameter so the "skip occurrences already past" rule can be
 * tested without waiting.
 *
 * NOTE: the student/tutor app has its own copy of this in
 * `src/lib/recurrence.ts`. Two products, two repositories, one rule —
 * if you change the behaviour here, change it there.
 */
export function expandWeekly(
  startLocal: string,
  durationMinutes: number,
  weekdays: number[],
  weeks: number,
  now: number = Date.now(),
): { startTime: string; endTime: string }[] {
  const base = new Date(startLocal);
  if (Number.isNaN(base.getTime())) return [];

  const slots: { startTime: string; endTime: string }[] = [];
  for (let week = 0; week < weeks; week++) {
    for (const weekday of weekdays) {
      const d = new Date(base);
      // Walk to the chosen weekday in local time, then add whole weeks.
      const delta = (weekday - base.getDay() + 7) % 7;
      d.setDate(base.getDate() + delta + week * 7);
      if (d.getTime() <= now) continue;
      const end = new Date(d.getTime() + durationMinutes * 60_000);
      slots.push({ startTime: d.toISOString(), endTime: end.toISOString() });
    }
  }
  return slots.sort((a, b) => a.startTime.localeCompare(b.startTime));
}
